import React, { Suspense } from 'react';

import { ChangePassword } from 'js/app/components/main/ChangePassword';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import { useTranslations } from 'js/hooks/i18n';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';

import style from './ChangePasswordPopup.scss';

export const ChangePasswordPopup = ({ id, onSuccess: onSuccessProp, onClose: onCloseProp }) => {
    const onClosePopup = useOnClose(id);
    const onSuccess = useCombinedHandler([onSuccessProp, onClosePopup]);
    const onClose = useCombinedHandler([onCloseProp, onClosePopup]);
    const t = useTranslations('playtech.mobile.system.changePass.');

    return (
        <ManagedPopup
            title={t('title')}
            onClose={onClose}
        >
            <Suspense fallback="">
                <ChangePassword
                    tKeyPrefix="popup."
                    onSuccess={onSuccess}
                    classNames={{
                        button: style.button,
                        form: style.form
                    }}
                />
            </Suspense>
        </ManagedPopup>
    );
};
